import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '../app/routes';
import checkGuestAndAuthenticated from './hooks/checkGuestAndAuthenticated';

Vue.use(VueRouter);

const index = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

index.beforeEach((to, from, next) => checkGuestAndAuthenticated(to, from, next));

export default index;
